import React from "react";
import { Bookmark } from "@mui/icons-material";
import feet1 from "../img/feet/feet1.png";
import feet2 from "../img/feet/feet2.png";
import feet3 from "../img/feet/feet3.png";
import feet4 from "../img/feet/feet4.png";

const Feet = ({ onImageClick }) => {
  return (
    <>
      <div className="help-center__examples help-center__examples--first">
        <div className="help-center__examples-header">
          <Bookmark />
          <h3 className="help-center__examples-title">Feets</h3>
        </div>

        <div className="help-center__example-card">
          <div className="help-center__example-images help-center__example-images--grid-4">
            <div className="help-center__image-placeholder help-center__image-placeholder--do">
              <div className="help-center__image-label">Do</div>
              <div className="help-center__image-box">
                <img src={feet1} alt="" onClick={() => onImageClick && onImageClick(feet1)} style={{cursor: 'pointer'}} />
              </div>
              <p className="help-center__image-caption">5 fingers</p>
            </div>

            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box">
                <img src={feet2} alt="" onClick={() => onImageClick && onImageClick(feet2)} style={{cursor: 'pointer'}} />
              </div>
              <p className="help-center__image-caption">Too much fingers</p>
            </div>

            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box">
                <img src={feet3} alt="" onClick={() => onImageClick && onImageClick(feet3)} style={{cursor: 'pointer'}} />
              </div>
              <p className="help-center__image-caption">Too much fingers</p>
            </div>

            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box">
                <img src={feet4} alt="" onClick={() => onImageClick && onImageClick(feet4)} style={{cursor: 'pointer'}} />
              </div>
              <p className="help-center__image-caption">Additional feet positioning mistake</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Feet;
